
// import React from "react";
// import "./contact.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faFacebookF, faTwitter, faInstagram, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
// import EnvelopeAnimation from "./Envolap";
// import Header from "../Home/Header";
// import Swal from "sweetalert2";

// const ContactForm = () => {
//   const handleFocus = (e) => {
//     e.target.parentNode.classList.add("focus");
//   };

//   const handleBlur = (e) => {
//     if (e.target.value === "") {
//       e.target.parentNode.classList.remove("focus");
//     }
//   };

//   const onSubmit = async (event) => {
//     event.preventDefault();
//     const formData = new FormData(event.target);

//     // Add access key for API
//     formData.append("access_key", "44165200-6289-4472-8486-185d74818a5e");

//     const jsonData = JSON.stringify(Object.fromEntries(formData));

//     try {
//       const response = await fetch("https://api.web3forms.com/submit", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: jsonData,
//       });

//       const result = await response.json();

//       if (result.success) {
//         Swal.fire({
//           title: "Success!",
//           text: "Your message has been sent.",
//           icon: "success",
//           confirmButtonText: "OK",
//           customClass: {
//             popup: "custom-orange-popup", // Apply custom CSS class
//             title: "custom-orange-title",
//             confirmButton: "custom-orange-button",
//           },
//         });
//         event.target.reset(); // Reset the form after successful submission
//       } else {
//         Swal.fire({
//           title: "Error",
//           text: "Form submission failed. Please try again.",
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//         console.error("Form submission failed:", result);
//       }
//     } catch (error) {
//       Swal.fire({
//         title: "Error",
//         text: "An unexpected error occurred. Please try again later.",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//       console.error("Error submitting form:", error);
//     }
//   };

//   return (
//     <>
//       <div className="containerss">
//         <span className="big-circle"></span>
//         <img src="img/shape.png" className="square" alt="Decorative Shape" />

//         <div className="form">
//           {/* Contact Info Section */}
//           <div className="contact-info">
//             <h3 className="title">Let's get in touch</h3>
//             <p className="text">
//               Feel free to reach out for any queries or collaboration opportunities. We'd love to hear from you!
//             </p>

//             <div className="info">
//               <EnvelopeAnimation />
//             </div>

//             <div className="social-media">
//               <p>Connect with us:</p>
//               <div className="social-icons">
//                 <a href="https://facebook.com" target="_blank" rel="noreferrer">
//                   <FontAwesomeIcon icon={faFacebookF} />
//                 </a>
//                 <a href="https://twitter.com" target="_blank" rel="noreferrer">
//                   <FontAwesomeIcon icon={faTwitter} />
//                 </a>
//                 <a href="https://instagram.com" target="_blank" rel="noreferrer">
//                   <FontAwesomeIcon icon={faInstagram} />
//                 </a>
//                 <a href="https://linkedin.com" target="_blank" rel="noreferrer">
//                   <FontAwesomeIcon icon={faLinkedinIn} />
//                 </a>
//               </div>
//             </div>
//           </div>

//           {/* Contact Form Section */}
//           <div className="contact-form">
//             <span className="circle one"></span>
//             <span className="circle two"></span>

//             <form autoComplete="off" onSubmit={onSubmit}>
//               <h3 className="title">Contact us</h3>

//               <div className="input-container">
//                 <input
//                   type="text"
//                   name="name"
//                   className="input"
//                   onFocus={handleFocus}
//                   onBlur={handleBlur}
//                   required
//                 />
//                 <label>Name</label>
//                 <span>Username</span>
//               </div>

//               <div className="input-container">
//                 <input
//                   type="email"
//                   name="email"
//                   className="input"
//                   onFocus={handleFocus}
//                   onBlur={handleBlur}
//                   required
//                 />
//                 <label>Email</label>
//                 <span>Email</span>
//               </div>

//               <div className="input-container">
//                 <input
//                   type="tel"
//                   name="phone"
//                   className="input"
//                   onFocus={handleFocus}
//                   onBlur={handleBlur}
//                   required
//                 />
//                 <label>Phone</label>
//                 <span>Phone</span>
//               </div>

//               <div className="input-container textarea">
//                 <textarea
//                   name="message"
//                   className="input"
//                   onFocus={handleFocus}
//                   onBlur={handleBlur}
//                   required
//                 ></textarea>
//                 <label>Message</label>
//                 <span>Message</span>
//               </div>

//               <input type="submit" value="Send" className="btn" />
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ContactForm;

// import React, { useState, useEffect } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faFacebookF,
//   faTwitter,
//   faInstagram,
//   faLinkedinIn,
// } from "@fortawesome/free-brands-svg-icons";
// import {
//   faPaperPlane,
//   faUser,
//   faPhone,
//   faEnvelope,
//   faMessage,
//   faMapMarkerAlt,
//   faClock,
//   faShieldAlt,
//   faCheck,
//   faSun,
// } from "@fortawesome/free-solid-svg-icons";
// import Swal from "sweetalert2";

// const ContactForm = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     message: ""
//   });
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [activeField, setActiveField] = useState(null);

//   // Floating particles effect
//   useEffect(() => {
//     const createParticles = () => {
//       const container = document.querySelector('.particles-container');
//       if (!container) return;

//       for (let i = 0; i < 20; i++) {
//         const particle = document.createElement('div');
//         particle.className = 'absolute rounded-full bg-orange-200/20';
//         particle.style.width = `${Math.random() * 20 + 10}px`;
//         particle.style.height = particle.style.width;
//         particle.style.left = `${Math.random() * 100}%`;
//         particle.style.top = `${Math.random() * 100}%`;
//         particle.style.animation = `float ${Math.random() * 5 + 5}s ease-in-out infinite`;
//         particle.style.animationDelay = `${Math.random() * 5}s`;
//         container.appendChild(particle);
//       }
//     };

//     createParticles();
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);

//     const formDataObj = new FormData(e.target);
//     formDataObj.append("access_key", "44165200-6289-4472-8486-185d74818a5e");

//     try {
//       const response = await fetch("https://api.web3forms.com/submit", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(Object.fromEntries(formDataObj))
//       });

//       const result = await response.json();

//       if (result.success) {
//         Swal.fire({
//           title: "🎉 Message Sent!",
//           text: "We'll get back to you within 24 hours.",
//           icon: "success",
//           background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
//           color: 'white',
//           confirmButtonColor: '#ea580c',
//           timer: 3000,
//           showConfirmButton: false
//         });

//         // Reset form
//         setFormData({ name: "", email: "", phone: "", message: "" });
//         setActiveField(null);
//       } else {
//         throw new Error('Submission failed');
//       }
//     } catch (error) {
//       Swal.fire({
//         title: "Oops!",
//         text: "Something went wrong. Please try again.",
//         icon: "error",
//         confirmButtonColor: '#f97316',
//       });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   const handleFocus = (field) => {
//     setActiveField(field);
//   };

//   const handleBlur = () => {
//     setActiveField(null);
//   };

//   const socialLinks = [
//     { icon: faFacebookF, color: "hover:bg-blue-600", label: "Facebook", bg: "bg-blue-500" },
//     { icon: faTwitter, color: "hover:bg-sky-500", label: "Twitter", bg: "bg-sky-400" },
//     { icon: faInstagram, color: "hover:bg-pink-600", label: "Instagram", bg: "bg-gradient-to-br from-pink-500 to-orange-500" },
//     { icon: faLinkedinIn, color: "hover:bg-blue-700", label: "LinkedIn", bg: "bg-blue-600" }
//   ];

//   const contactDetails = [
//     { icon: faMapMarkerAlt, title: "Our Location", text: "123 Orange Street, Sunny City", color: "bg-orange-500" },
//     { icon: faPhone, title: "Phone Number", text: "+1 (555) 123-4567", color: "bg-amber-500" },
//     { icon: faEnvelope, title: "Email Address", text: "hello@orangecreative.com", color: "bg-yellow-500" },
//     { icon: faClock, title: "Response Time", text: "Within 24 hours", color: "bg-orange-400" }
//   ];

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-50 py-12 px-4 relative overflow-hidden">
//       {/* Animated Particles */}
//       <div className="particles-container absolute inset-0 overflow-hidden pointer-events-none" />

//       {/* Sun Background Effect */}
//       <div className="absolute top-1/4 right-10 w-96 h-96 bg-gradient-to-br from-orange-200/30 to-amber-200/20 rounded-full blur-3xl animate-pulse" />
//       <div className="absolute bottom-1/4 left-10 w-80 h-80 bg-gradient-to-tr from-yellow-200/20 to-orange-200/10 rounded-full blur-3xl" />

//       {/* Main Container */}
//       <div className="max-w-7xl mx-auto relative z-10">
//         {/* Header */}
//         <div className="text-center mb-16 animate-fade-in">
//           <div className="inline-flex items-center justify-center mb-4">
//             <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-amber-500 rounded-full flex items-center justify-center shadow-lg shadow-orange-200">
//               <FontAwesomeIcon icon={faSun} className="text-white text-2xl" />
//             </div>
//           </div>
//           <h1 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-orange-600 to-amber-600 bg-clip-text text-transparent mb-4">
//             Let's Create Together
//           </h1>
//           <p className="text-xl text-gray-600 max-w-2xl mx-auto">
//             Got a bright idea? Let's make it shine! Share your vision with us and watch it come to life.
//           </p>
//         </div>

//         <div className="grid lg:grid-cols-2 gap-8">
//           {/* Left Side - Contact Info */}
//           <div className="space-y-8">
//             {/* Stats Cards */}
//             <div className="grid grid-cols-2 gap-6">
//               {[
//                 { value: "100+", label: "Happy Clients", color: "from-orange-500 to-amber-500" },
//                 { value: "24/7", label: "Support", color: "from-amber-500 to-yellow-500" },
//                 { value: "40+", label: "Projects Done", color: "from-yellow-500 to-orange-400" },
//                 { value: "99%", label: "Satisfaction", color: "from-orange-400 to-red-500" }
//               ].map((stat, idx) => (
//                 <div 
//                   key={idx}
//                   className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-orange-100"
//                 >
//                   <div className={`text-3xl font-bold bg-gradient-to-r ${stat.color} bg-clip-text text-transparent mb-2`}>
//                     {stat.value}
//                   </div>
//                   <div className="text-gray-600 font-medium">{stat.label}</div>
//                 </div>
//               ))}
//             </div>

//             {/* Contact Details Card */}
//             <div className="bg-white/90 backdrop-blur-sm rounded-3xl p-8 shadow-2xl shadow-orange-100/50 border border-orange-100">
//               <h2 className="text-3xl font-bold bg-gradient-to-r from-orange-600 to-amber-600 bg-clip-text text-transparent mb-8">
//                 Get in Touch
//               </h2>
              
//               <div className="space-y-6 mb-8">
//                 {contactDetails.map((detail, idx) => (
//                   <div 
//                     key={idx}
//                     className="flex items-center gap-4 p-4 rounded-xl hover:bg-orange-50 transition-all duration-300 group hover:translate-x-2"
//                   >
//                     <div className={`${detail.color} w-12 h-12 rounded-xl flex items-center justify-center shadow-lg transition-transform duration-300 group-hover:scale-110`}>
//                       <FontAwesomeIcon icon={detail.icon} className="text-white text-lg" />
//                     </div>
//                     <div>
//                       <h3 className="font-semibold text-gray-800">{detail.title}</h3>
//                       <p className="text-gray-600">{detail.text}</p>
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               {/* Social Links */}
//               <div>
//                 <h3 className="text-lg font-semibold text-gray-800 mb-4">Connect With Us</h3>
//                 <div className="flex gap-4">
//                   {socialLinks.map((social, idx) => (
//                     <a
//                       key={idx}
//                       href="#"
//                       className={`${social.bg} ${social.color} w-12 h-12 rounded-xl flex items-center justify-center text-white shadow-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-xl relative group`}
//                       aria-label={social.label}
//                     >
//                       <FontAwesomeIcon icon={social.icon} />
//                       <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-gray-900 text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
//                         {social.label}
//                       </div>
//                     </a>
//                   ))}
//                 </div>
//               </div>

//               {/* Security Badge */}
//               <div className="mt-8 bg-gradient-to-r from-orange-50 to-amber-50 rounded-2xl p-5 border border-orange-100">
//                 <div className="flex items-center gap-3">
//                   <div className="w-10 h-10 bg-orange-100 rounded-xl flex items-center justify-center">
//                     <FontAwesomeIcon icon={faShieldAlt} className="text-orange-600" />
//                   </div>
//                   <div>
//                     <p className="text-sm font-medium text-orange-800">Your data is protected</p>
//                     <p className="text-xs text-orange-600">Secure & encrypted connection</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Right Side - Contact Form */}
//           <div className="bg-gradient-to-br from-white to-orange-50 rounded-3xl p-8 shadow-2xl shadow-orange-200/50 border border-orange-100 relative overflow-hidden">
//             {/* Decorative Elements */}
//             <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-orange-200/20 to-amber-200/10 rounded-full -translate-y-16 translate-x-16" />
//             <div className="absolute bottom-0 left-0 w-40 h-40 bg-gradient-to-tr from-yellow-200/10 to-orange-200/10 rounded-full -translate-x-16 translate-y-16" />

//             <div className="relative z-10">
//               <div className="mb-8">
//                 <h2 className="text-3xl font-bold bg-gradient-to-r from-orange-600 to-amber-600 bg-clip-text text-transparent mb-2">
//                   Send Your Message
//                 </h2>
//                 <p className="text-gray-600">Fill out the form below and we'll get back to you soon</p>
//               </div>

//               <form onSubmit={handleSubmit} className="space-y-6">
//                 {/* Name Field */}
//                 <div className="relative">
//                   <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
//                     <FontAwesomeIcon icon={faUser} />
//                   </div>
//                   <input
//                     type="text"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     onFocus={() => handleFocus('name')}
//                     onBlur={handleBlur}
//                     className={`w-full pl-12 pr-4 py-4 bg-white border-2 rounded-2xl focus:outline-none transition-all duration-300 ${
//                       activeField === 'name' 
//                         ? 'border-orange-500 shadow-lg shadow-orange-200' 
//                         : 'border-orange-100 hover:border-orange-300'
//                     }`}
//                     placeholder="Your Full Name"
//                     required
//                   />
//                   {formData.name && (
//                     <div className="absolute right-4 top-1/2 -translate-y-1/2">
//                       <FontAwesomeIcon icon={faCheck} className="text-green-500" />
//                     </div>
//                   )}
//                 </div>

//                 {/* Email Field */}
//                 <div className="relative">
//                   <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
//                     <FontAwesomeIcon icon={faEnvelope} />
//                   </div>
//                   <input
//                     type="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     onFocus={() => handleFocus('email')}
//                     onBlur={handleBlur}
//                     className={`w-full pl-12 pr-4 py-4 bg-white border-2 rounded-2xl focus:outline-none transition-all duration-300 ${
//                       activeField === 'email' 
//                         ? 'border-orange-500 shadow-lg shadow-orange-200' 
//                         : 'border-orange-100 hover:border-orange-300'
//                     }`}
//                     placeholder="Your Email Address"
//                     required
//                   />
//                   {formData.email && (
//                     <div className="absolute right-4 top-1/2 -translate-y-1/2">
//                       <FontAwesomeIcon icon={faCheck} className="text-green-500" />
//                     </div>
//                   )}
//                 </div>

//                 {/* Phone Field */}
//                 <div className="relative">
//                   <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
//                     <FontAwesomeIcon icon={faPhone} />
//                   </div>
//                   <input
//                     type="tel"
//                     name="phone"
//                     value={formData.phone}
//                     onChange={handleChange}
//                     onFocus={() => handleFocus('phone')}
//                     onBlur={handleBlur}
//                     className={`w-full pl-12 pr-4 py-4 bg-white border-2 rounded-2xl focus:outline-none transition-all duration-300 ${
//                       activeField === 'phone' 
//                         ? 'border-orange-500 shadow-lg shadow-orange-200' 
//                         : 'border-orange-100 hover:border-orange-300'
//                     }`}
//                     placeholder="Your Phone Number"
//                     required
//                   />
//                   {formData.phone && (
//                     <div className="absolute right-4 top-1/2 -translate-y-1/2">
//                       <FontAwesomeIcon icon={faCheck} className="text-green-500" />
//                     </div>
//                   )}
//                 </div>

//                 {/* Message Field */}
//                 <div className="relative">
//                   <div className="absolute left-4 top-6 text-gray-400">
//                     <FontAwesomeIcon icon={faMessage} />
//                   </div>
//                   <textarea
//                     name="message"
//                     value={formData.message}
//                     onChange={handleChange}
//                     onFocus={() => handleFocus('message')}
//                     onBlur={handleBlur}
//                     rows="5"
//                     className={`w-full pl-12 pr-4 py-4 bg-white border-2 rounded-2xl focus:outline-none transition-all duration-300 resize-none ${
//                       activeField === 'message' 
//                         ? 'border-orange-500 shadow-lg shadow-orange-200' 
//                         : 'border-orange-100 hover:border-orange-300'
//                     }`}
//                     placeholder="Tell us about your project..."
//                     required
//                   />
//                   <div className="absolute bottom-3 right-3 text-xs text-gray-400">
//                     {formData.message.length}/500
//                   </div>
//                 </div>

//                 {/* Submit Button */}
//                 <button
//                   type="submit"
//                   disabled={isSubmitting}
//                   className="w-full py-4 px-6 bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white font-semibold rounded-2xl shadow-lg shadow-orange-200 hover:shadow-xl hover:shadow-orange-300 transition-all duration-300 transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center gap-3 group"
//                 >
//                   {isSubmitting ? (
//                     <>
//                       <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
//                       <span>Sending...</span>
//                     </>
//                   ) : (
//                     <>
//                       <span>Send Message</span>
//                       <FontAwesomeIcon 
//                         icon={faPaperPlane} 
//                         className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" 
//                       />
//                     </>
//                   )}
//                 </button>

//                 {/* Privacy Note */}
//                 <div className="text-center pt-4">
//                   <p className="text-sm text-gray-500 flex items-center justify-center gap-2">
//                     <FontAwesomeIcon icon={faShieldAlt} className="text-orange-500" />
//                     <span>Your information is safe with us. We never share your data.</span>
//                   </p>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>

//         {/* Testimonial Section */}
//         <div className="mt-16 text-center">
//           <h3 className="text-2xl font-bold text-gray-800 mb-8">What Our Clients Say</h3>
//           <div className="grid md:grid-cols-3 gap-8">
//             {[
//               { name: "Sarah Johnson", role: "Marketing Director", text: "Their team turned our vision into reality with incredible attention to detail.", color: "bg-gradient-to-r from-orange-100 to-amber-100" },
//               { name: "Michael Chen", role: "Startup Founder", text: "Professional, creative, and delivered beyond expectations. Highly recommended!", color: "bg-gradient-to-r from-amber-100 to-yellow-100" },
//               { name: "Emma Rodriguez", role: "Product Manager", text: "The communication was exceptional throughout the entire project lifecycle.", color: "bg-gradient-to-r from-yellow-100 to-orange-100" }
//             ].map((testimonial, idx) => (
//               <div 
//                 key={idx}
//                 className={`${testimonial.color} rounded-3xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-orange-100`}
//               >
//                 <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-amber-500 rounded-full flex items-center justify-center text-white font-bold text-lg mb-4 mx-auto">
//                   {testimonial.name.charAt(0)}
//                 </div>
//                 <p className="text-gray-600 italic mb-4">"{testimonial.text}"</p>
//                 <div>
//                   <p className="font-semibold text-gray-800">{testimonial.name}</p>
//                   <p className="text-sm text-gray-500">{testimonial.role}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Add custom animations */}
//       <style jsx>{`
//         @keyframes float {
//           0%, 100% { transform: translateY(0) rotate(0deg); }
//           50% { transform: translateY(-20px) rotate(5deg); }
//         }
        
//         @keyframes fadeIn {
//           from { opacity: 0; transform: translateY(20px); }
//           to { opacity: 1; transform: translateY(0); }
//         }
        
//         .animate-fade-in {
//           animation: fadeIn 0.8s ease-out;
//         }
        
//         /* Custom scrollbar */
//         ::-webkit-scrollbar {
//           width: 8px;
//         }
        
//         ::-webkit-scrollbar-track {
//           background: #fef3c7;
//         }
        
//         ::-webkit-scrollbar-thumb {
//           background: linear-gradient(to bottom, #f97316, #f59e0b);
//           border-radius: 4px;
//         }
        
//         ::-webkit-scrollbar-thumb:hover {
//           background: linear-gradient(to bottom, #ea580c, #d97706);
//         }
        
//         /* Selection color */
//         ::selection {
//           background-color: rgba(249, 115, 22, 0.3);
//           color: #7c2d12;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default ContactForm;





















// import React, { useState, useRef, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { apiService } from '../../services/api';
// import { 
//   FaUser, 
//   FaEnvelope, 
//   FaPhone, 
//   FaMapMarkerAlt, 
//   FaHome,
//   FaBuilding,
//   FaGlobe,
//   FaPaperPlane,
//   FaCheckCircle,
//   FaArrowRight,
//   FaStar,
//   FaClock,
//   FaUsers,
//   FaShieldAlt,
//   FaPlay,
//   FaPause,
//   FaCheck,
//   FaTools,
//   FaPaintRoller,
//   FaTape,
//   FaTint,
//   FaPlug,
//   FaWrench,
//   FaCalendarAlt,
//   FaCalendarDay,
//   FaTimesCircle
// } from 'react-icons/fa';
// import toast from 'react-hot-toast';


// const ContactPage = () => {
//   const navigate = useNavigate();
//   const videoRef = useRef(null);
//   const [isPlaying, setIsPlaying] = useState(true);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [submitError, setSubmitError] = useState(null);
//   const [activeField, setActiveField] = useState('');
  
//   // Form data structure
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     preferredDate: '',
//     preferredTime: '',
//     address: {
//       street: '',
//       city: '',
//       state: '',
//       country: 'USA', // Default to USA
//       zipCode: ''
//     },
//     subject: 'Kitchen Cabinet Inquiry',
//     message: '',
//     sendCopy: true
//   });

//   // New Jersey Business Hours (Tuesday-Saturday, Closed Sunday & Monday)
//   const businessHours = [
//     { day: 'Monday', hours: 'Closed', isClosed: true },
//     { day: 'Tuesday', hours: '10:00 AM – 5:00 PM', isClosed: false },
//     { day: 'Wednesday', hours: '10:00 AM – 5:00 PM', isClosed: false },
//     { day: 'Thursday', hours: '10:00 AM – 5:00 PM', isClosed: false },
//     { day: 'Friday', hours: '10:00 AM – 5:00 PM', isClosed: false },
//     { day: 'Saturday', hours: '10:00 AM – 2:00 PM', isClosed: false }, // Shortened Saturday hours
//     { day: 'Sunday', hours: 'Closed', isClosed: true }
//   ];

//   // Time slots available (Tuesday-Friday 10-5, Saturday 10-2)
//   const timeSlots = [
//     '10:00 AM to 12:00 PM',
//     '12:00 PM to 02:00 PM',
//     '02:00 PM to 04:00 PM'
//   ];

//   // Saturday-only time slots
//   const saturdayTimeSlots = [
//     '10:00 AM to 12:00 PM',
//     '12:00 PM to 02:00 PM'
//   ];

//   // What We Offer features
//   const features = [
//     { icon: <FaBuilding />, title: 'Cabinets', description: 'Premium quality cabinets custom-built to your specifications' },
//     { icon: <FaTools />, title: 'Countertops', description: 'Durable and beautiful countertop installation' },
//     { icon: <FaTape />, title: 'Backsplash', description: 'Professional backsplash design and installation' },
//     { icon: <FaPaintRoller />, title: 'Paint', description: 'Complete painting services for your kitchen' },
//     { icon: <FaTint />, title: 'Sink', description: 'High-quality sink installation with plumbing' },
//     { icon: <FaWrench />, title: 'Hardware', description: 'Knobs, pulls, and all finishing hardware' },
//     { icon: <FaPlug />, title: 'Electrical', description: 'Any necessary electrical work included' },
//     { icon: <FaWrench />, title: 'Complete Labor', description: 'Full installation from start to finish' }
//   ];

//   const toggleVideo = () => {
//     if (videoRef.current) {
//       if (isPlaying) {
//         videoRef.current.pause();
//       } else {
//         videoRef.current.play();
//       }
//       setIsPlaying(!isPlaying);
//     }
//   };

//   useEffect(() => {
//     if (videoRef.current) {
//       videoRef.current.play().catch(e => {
//         console.log("Autoplay prevented:", e);
//       });
//     }
//   }, []);

//   // Function to get minimum date (tomorrow)
//   const getMinDate = () => {
//     const tomorrow = new Date();
//     tomorrow.setDate(tomorrow.getDate() + 1);
//     return tomorrow.toISOString().split('T')[0];
//   };

//   // Function to get maximum date (60 days from now)
//   const getMaxDate = () => {
//     const maxDate = new Date();
//     maxDate.setDate(maxDate.getDate() + 60);
//     return maxDate.toISOString().split('T')[0];
//   };

//   // Function to check if a date is Monday or Sunday
//   const isClosedDay = (dateString) => {
//     if (!dateString) return false;
//     const date = new Date(dateString);
//     const day = date.getDay(); // 0 = Sunday, 1 = Monday
//     return day === 0 || day === 1; // Closed on Sunday and Monday
//   };

//   // Function to check if date is Saturday
//   const isSaturday = (dateString) => {
//     if (!dateString) return false;
//     const date = new Date(dateString);
//     return date.getDay() === 6; // 6 = Saturday
//   };

//   // Function to get day name from date
//   const getDayName = (dateString) => {
//     if (!dateString) return '';
//     const date = new Date(dateString);
//     const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
//     return days[date.getDay()];
//   };

//   // Get time slots based on selected date
//   const getAvailableTimeSlots = () => {
//     if (!formData.preferredDate) return timeSlots;
//     if (isSaturday(formData.preferredDate)) {
//       return saturdayTimeSlots;
//     }
//     return timeSlots;
//   };

//   const validateForm = () => {
//     const errors = {};

//     if (!formData.name.trim()) {
//       errors.name = 'Name is required';
//     }

//     // Email is optional but must be valid if provided
//     if (formData.email.trim() && !/\S+@\S+\.\S+/.test(formData.email)) {
//       errors.email = 'Email is invalid';
//     }

//     // Phone validation - flexible for international numbers
//     if (!formData.phone.trim()) {
//       errors.phone = 'Phone number is required';
//     } else if (!/^[\d\s\-\+\(\)]{10,20}$/.test(formData.phone)) {
//       errors.phone = 'Enter a valid phone number (10-20 digits, international format accepted)';
//     }

//     // Check if preferred date is Monday or Sunday
//     if (formData.preferredDate && isClosedDay(formData.preferredDate)) {
//       const dayName = getDayName(formData.preferredDate);
//       errors.preferredDate = `We are closed on ${dayName}s. Please select another date.`;
//     }

//     // Check if time is selected but no date
//     if (formData.preferredTime && !formData.preferredDate) {
//       errors.preferredDate = 'Please select a date first';
//     }

//     if (!formData.message.trim()) {
//       errors.message = 'Message is required';
//     } else if (formData.message.length < 5) {
//       errors.message = 'Message must be at least 5 characters';
//     }

//     return errors;
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
    
//     if (name.includes('.')) {
//       const [parent, child] = name.split('.');
//       setFormData(prev => ({
//         ...prev,
//         [parent]: {
//           ...prev[parent],
//           [child]: value
//         }
//       }));
//     } else {
//       setFormData(prev => ({
//         ...prev,
//         [name]: type === 'checkbox' ? checked : value
//       }));
//     }
//   };

//   const handleDateChange = (e) => {
//     const selectedDate = e.target.value;
    
//     // Check if selected date is Monday or Sunday
//     if (isClosedDay(selectedDate)) {
//       const dayName = getDayName(selectedDate);
//       toast.error(`We are closed on ${dayName}s. Please select another date.`);
//       setFormData(prev => ({
//         ...prev,
//         preferredDate: '',
//         preferredTime: '' // Clear time if closed day is selected
//       }));
//       return;
//     }
    
//     setFormData(prev => ({
//       ...prev,
//       preferredDate: selectedDate,
//       preferredTime: '' // Reset time when date changes
//     }));
//   };

//   const handleTimeChange = (e) => {
//     const selectedTime = e.target.value;
//     setFormData(prev => ({
//       ...prev,
//       preferredTime: selectedTime
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     // Clear previous errors
//     setSubmitError(null);
    
//     const errors = validateForm();
//     if (Object.keys(errors).length > 0) {
//       Object.values(errors).forEach(error => {
//         if (error) toast.error(error);
//       });
//       return;
//     }

//     setIsSubmitting(true);

//     // Debug log
//     console.log('Submitting form data:', formData);

//     // Prepare data for backend - keep phone format as entered
//     const submissionData = {
//       ...formData,
//       phone: formData.phone.trim(), // Keep original formatting
//       preferredDate: formData.preferredDate || null,
//       preferredTime: formData.preferredTime || '',
//       timestamp: new Date().toISOString()
//     };

//     try {
//       console.log('Calling API with:', submissionData);
      
//       const response = await apiService.submitContact(submissionData);
      
//       console.log('API Response:', response);
      
//       if (response.success) {
//         toast.success('Message sent successfully! We will contact you within 24 hours.');
        
//         // Prepare submission data BEFORE resetting form
//         const submissionDataForThankYou = {
//           name: formData.name,
//           email: formData.email,
//           phone: formData.phone,
//           preferredDate: formData.preferredDate,
//           preferredTime: formData.preferredTime,
//           subject: formData.subject,
//           message: formData.message,
//           address: formData.address,
//           // Use response.data only if it exists
//           ...(response.data && { ...response.data }),
//           submittedAt: new Date().toLocaleString()
//         };
        
//         // Reset form
//         setFormData({
//           name: '',
//           email: '',
//           phone: '',
//           preferredDate: '',
//           preferredTime: '',
//           address: {
//             street: '',
//             city: '',
//             state: '',
//             country: 'USA',
//             zipCode: ''
//           },
//           subject: 'Kitchen Cabinet Inquiry',
//           message: '',
//           sendCopy: true
//         });

//         // Navigate to thank you page
//         setTimeout(() => {
//           navigate('/thank-you', { 
//             state: { 
//               submissionData: submissionDataForThankYou
//             } 
//           });
//         }, 1500);

//       } else {
//         const errorMessage = response.message || 'Failed to send message. Please try again.';
//         setSubmitError(errorMessage);
//         toast.error(errorMessage);
//       }
//     } catch (error) {
//       console.error('Error submitting form:', error);
//       const errorMessage = error.message || 'Network error. Please check your connection and try again.';
//       setSubmitError(errorMessage);
      
//       // Provide more specific error messages
//       if (error.response) {
//         toast.error(`Server error: ${error.response.status}`);
//       } else if (error.request) {
//         toast.error('No response from server. Please try again later.');
//       } else {
//         toast.error('Failed to send message. Please try again.');
//       }
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // Get current day for highlighting
//   const getCurrentDay = () => {
//     const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
//     return days[new Date().getDay()];
//   };

//   // Get available time slots for selected date
//   const availableTimeSlots = getAvailableTimeSlots();

//   return (
//     <div className="min-h-screen bg-gradient-to-b from-white via-orange-50/20 to-white">
//       {/* Hero Section with Video Background */}
//       <section className="relative h-[60vh] sm:h-[70vh] md:h-[75vh] lg:h-[80vh] overflow-hidden">
//         <div className="absolute inset-0">
//           <video
//             ref={videoRef}
//             autoPlay
//             muted
//             loop
//             playsInline
//             className="absolute inset-0 w-full h-full object-cover"
//             poster="/assets/Images/video-poster.jpg"
//           >
//             <source src="/assets/Images/mobilevideo.mp4" type="video/mp4" />
//             Your browser does not support the video tag.
//           </video>
          
//           <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-transparent md:bg-gradient-to-r md:from-black/80 md:via-black/50 md:to-transparent">
//             <div className="container mx-auto h-full px-4 sm:px-6 lg:px-8 flex items-center">
//               <div className="max-w-3xl w-full">
//                 <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-4 sm:mb-6">
//                   <FaStar className="text-orange-300 text-sm" />
//                   <span className="text-white text-xs sm:text-sm font-medium">Premium Cabinetry Solutions</span>
//                 </div>
                
//                 <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-bold text-white mb-3 sm:mb-4 leading-tight">
//                   Custom Kitchen Cabinets & Premium Cabinet Solutions by{' '}
//                   <span className="text-orange-300">Laminance Cabinetry</span>
//                 </h1>
                
//                 <p className="text-base sm:text-lg md:text-xl text-white/90 mb-6 sm:mb-8 max-w-2xl">
//                   Complete kitchen transformations with all-inclusive packages. From concept to completion, we handle everything.
//                 </p>
                
//                 <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
//                   <button
//                     onClick={() => document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' })}
//                     className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-6 sm:px-8 py-3 rounded-lg sm:rounded-xl flex items-center justify-center transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg text-sm sm:text-base"
//                   >
//                     <FaPaperPlane className="mr-2 sm:mr-3" />
//                     Get Free Consultation
//                   </button>
                  
//                   <button
//                     onClick={toggleVideo}
//                     className="bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white font-semibold px-4 sm:px-6 py-3 rounded-lg sm:rounded-xl flex items-center justify-center transition-all text-sm sm:text-base"
//                   >
//                     {isPlaying ? (
//                       <>
//                         <FaPause className="mr-2 sm:mr-3" />
//                         <span className="hidden sm:inline">Pause Video</span>
//                         <span className="sm:hidden">Pause</span>
//                       </>
//                     ) : (
//                       <>
//                         <FaPlay className="mr-2 sm:mr-3" />
//                         <span className="hidden sm:inline">Play Video</span>
//                         <span className="sm:hidden">Play</span>
//                       </>
//                     )}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* What We Offer Section */}
//       <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-orange-50/30">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-8 sm:mb-12">
//             <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
//               All-Inclusive Kitchen Transformation
//             </h2>
//             <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto px-4">
//               Everything you need for a complete kitchen renovation, handled by our expert team from start to finish.
//             </p>
//           </div>

//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-8 sm:mb-12 px-2 sm:px-0">
//             {features.map((feature, index) => (
//               <div
//                 key={index}
//                 className="bg-white p-4 sm:p-6 rounded-xl sm:rounded-2xl border border-gray-200 hover:border-orange-300 transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
//               >
//                 <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-r from-orange-100 to-orange-50 rounded-lg sm:rounded-xl flex items-center justify-center mb-3 sm:mb-4">
//                   <div className="text-orange-600 text-lg sm:text-xl">
//                     {feature.icon}
//                   </div>
//                 </div>
//                 <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-1 sm:mb-2">
//                   {feature.title}
//                 </h3>
//                 <p className="text-gray-600 text-xs sm:text-sm">
//                   {feature.description}
//                 </p>
//               </div>
//             ))}
//           </div>

//           <div className="bg-gradient-to-r from-orange-500 to-orange-600 rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 text-white">
//             <div className="max-w-4xl mx-auto text-center">
//               <h3 className="text-xl sm:text-2xl md:text-3xl font-bold mb-3 sm:mb-4">Complete Package. Zero Stress.</h3>
//               <p className="text-sm sm:text-base md:text-lg mb-4 sm:mb-6 px-2">
//                 Our all-inclusive service includes cabinets, countertops, backsplash, paint, sink, 
//                 knobs and all materials needed to finish your kitchen. We handle the entire labor 
//                 to install kitchen, countertops, backsplash, any electric and plumbing work.
//               </p>
//               <div className="flex flex-wrap justify-center gap-2 sm:gap-3 md:gap-4">
//                 <div className="bg-white/20 backdrop-blur-sm px-3 py-1 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm">
//                   <span className="font-semibold">No Hidden Costs</span>
//                 </div>
//                 <div className="bg-white/20 backdrop-blur-sm px-3 py-1 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm">
//                   <span className="font-semibold">Single Point of Contact</span>
//                 </div>
//                 <div className="bg-white/20 backdrop-blur-sm px-3 py-1 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm">
//                   <span className="font-semibold">Guaranteed Timeline</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Contact Form Section */}
//       <section id="contact-form" className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 lg:px-8">
//         <div className="max-w-6xl mx-auto">
//           <div className="text-center mb-8 sm:mb-12">
//             <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
//               Start Your Dream Project
//             </h2>
//             <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
//               Fill out the form below and our team will contact you within 24 hours to discuss your project.
//             </p>
            
//             {/* Error Display */}
//             {submitError && (
//               <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-xl max-w-md mx-auto">
//                 <p className="text-red-600 font-medium">Error: {submitError}</p>
//                 <p className="text-red-500 text-sm mt-1">Please try again or call us directly at (862) 450-6069</p>
//               </div>
//             )}
//           </div>

//           <div className="grid lg:grid-cols-3 gap-6 sm:gap-8">
//             {/* Contact Info Sidebar */}
//             <div className="lg:col-span-1">
//               <div className="bg-gradient-to-b from-orange-600 to-orange-700 rounded-2xl sm:rounded-3xl p-6 sm:p-8 text-white h-full">
//                 <div className="mb-8 sm:mb-10">
//                   <h3 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6">Business Hours</h3>
//                   <div className="space-y-2">
//                     {businessHours.map((day, index) => {
//                       const isToday = day.day === getCurrentDay();
//                       return (
//                         <div 
//                           key={index} 
//                           className={`flex items-center justify-between p-3 rounded-lg ${
//                             isToday ? 'bg-white/20' : 'bg-white/10'
//                           }`}
//                         >
//                           <div className="flex items-center space-x-3">
//                             {day.isClosed ? (
//                               <FaTimesCircle className="text-orange-200" />
//                             ) : (
//                               <FaClock className="text-orange-200" />
//                             )}
//                             <span className={`font-medium ${isToday ? 'text-orange-300' : ''}`}>
//                               {day.day}
//                               {isToday && <span className="ml-2 text-xs bg-orange-500 px-2 py-1 rounded-full">Today</span>}
//                             </span>
//                           </div>
//                           <span className={`font-semibold ${day.isClosed ? 'text-orange-200' : ''}`}>
//                             {day.hours}
//                           </span>
//                         </div>
//                       );
//                     })}
//                   </div>
                  
//                 </div>

//                 <div className="mb-8 sm:mb-10">
//                   <h3 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6">Why Choose Us</h3>
//                   <div className="space-y-4 sm:space-y-6">
//                     {[
//                       { icon: <FaUsers />, title: 'Expert Team', desc: '15+ years of specialized experience' },                    
//                       { icon: <FaShieldAlt />, title: 'Warranty', desc: '5-year comprehensive warranty' }
//                     ].map((item, index) => (
//                       <div key={index} className="flex items-start space-x-3 sm:space-x-4">
//                         <div className="w-8 h-8 sm:w-10 sm:h-10 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
//                           {item.icon}
//                         </div>
//                         <div>
//                           <h4 className="font-semibold text-sm sm:text-base">{item.title}</h4>
//                           <p className="text-orange-100 text-xs sm:text-sm mt-1">{item.desc}</p>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 <div className="border-t border-white/20 pt-6 sm:pt-8">
//                   <h3 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6">Contact Directly</h3>
//                   <div className="space-y-3 sm:space-y-4">
//                     <a 
//                       href="tel:8624506069"
//                       className="flex items-center justify-between p-3 bg-white/10 rounded-xl hover:bg-white/20 transition-all text-sm sm:text-base"
//                     >
//                       <span className="font-medium">Call Now</span>
//                       <span className="font-bold">(862) 450-6069</span>
//                     </a>
//                     <a 
//                       href="mailto:Contactus@laminance.com"
//                       className="flex items-center justify-between p-3 bg-white/10 rounded-xl hover:bg-white/20 transition-all text-sm sm:text-base"
//                     >
//                       <span className="font-medium">Email Us</span>
//                       <span className="font-bold">Contactus@laminance.com</span>
//                     </a>
                    
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Contact Form */}
//             <div className="lg:col-span-2">
//               <div className="bg-white rounded-2xl sm:rounded-3xl border border-gray-200 p-4 sm:p-6 md:p-8 shadow-lg">
//                 <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
//                     {/* Name Field */}
//                     <div>
//                       <label className="block text-sm font-semibold text-gray-700 mb-2">
//                         Full Name *
//                       </label>
//                       <div className="relative">
//                         <input
//                           type="text"
//                           name="name"
//                           value={formData.name}
//                           onChange={handleChange}
//                           onFocus={() => setActiveField('name')}
//                           onBlur={() => setActiveField('')}
//                           required
//                           className="w-full pl-3 sm:pl-4 pr-3 sm:pr-4 py-3 sm:py-3.5 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:ring-2 focus:ring-orange-100 outline-none transition-all text-gray-700 placeholder:text-gray-400 text-sm sm:text-base"
//                           placeholder="John Smith"
//                         />
//                       </div>
//                     </div>

//                     {/* Email Field - Optional */}
//                     <div>
//                       <label className="block text-sm font-semibold text-gray-700 mb-2">
//                         Email Address (Optional)
//                       </label>
//                       <div className="relative">
//                         <input
//                           type="email"
//                           name="email"
//                           value={formData.email}
//                           onChange={handleChange}
//                           onFocus={() => setActiveField('email')}
//                           onBlur={() => setActiveField('')}
//                           className="w-full pl-3 sm:pl-4 pr-3 sm:pr-4 py-3 sm:py-3.5 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:ring-2 focus:ring-orange-100 outline-none transition-all text-gray-700 placeholder:text-gray-400 text-sm sm:text-base"
//                           placeholder="Contactus@laminance.com"
//                         />
//                       </div>
//                     </div>
//                   </div>

//                   {/* Phone Field - Updated for international numbers */}
//                   <div>
//                     <label className="block text-sm font-semibold text-gray-700 mb-2">
//                       Phone Number *
//                     </label>
//                     <div className="relative">
//                       <input
//                         type="tel"
//                         name="phone"
//                         value={formData.phone}
//                         onChange={handleChange}
//                         onFocus={() => setActiveField('phone')}
//                         onBlur={() => setActiveField('')}
//                         required
//                         className="w-full pl-3 sm:pl-4 pr-3 sm:pr-4 py-3 sm:py-3.5 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:ring-2 focus:ring-orange-100 outline-none transition-all text-gray-700 placeholder:text-gray-400 text-sm sm:text-base"
//                         placeholder="+1 (862) 450-6069 or 8624506069"
//                       />
//                       <p className="text-xs text-gray-500 mt-2">
//                         Enter phone number in any format (10-20 digits). International numbers accepted.
//                       </p>
//                     </div>
//                   </div>

//                   {/* Preferred Date and Time Section */}
                 

//                   {/* Address Section */}
//                   <div className="space-y-3 sm:space-y-4">
//                     <div className="flex items-center space-x-3">
//                       <div className="w-8 h-8 sm:w-10 sm:h-10 bg-orange-100 rounded-lg flex items-center justify-center">
//                         <FaHome className="text-orange-600 text-sm sm:text-base" />
//                       </div>
//                       <h3 className="text-base sm:text-lg font-semibold text-gray-800">Project Address (Optional)</h3>
//                     </div>

//                     <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
//                       <input
//                         type="text"
//                         name="address.street"
//                         value={formData.address.street}
//                         onChange={handleChange}
//                         className="w-full px-3 sm:px-4 py-3 sm:py-3.5 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:ring-2 focus:ring-orange-100 outline-none transition-all text-sm sm:text-base"
//                         placeholder="Street address"
//                       />
//                       <input
//                         type="text"
//                         name="address.city"
//                         value={formData.address.city}
//                         onChange={handleChange}
//                         className="w-full px-3 sm:px-4 py-3 sm:py-3.5 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:ring-2 focus:ring-orange-100 outline-none transition-all text-sm sm:text-base"
//                         placeholder="City"
//                       />
//                     </div>

//                     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
//                       <input
//                         type="text"
//                         name="address.state"
//                         value={formData.address.state}
//                         onChange={handleChange}
//                         className="w-full px-3 sm:px-4 py-3 sm:py-3.5 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:ring-2 focus:ring-orange-100 outline-none transition-all text-sm sm:text-base"
//                         placeholder="State (e.g., NJ)"
//                       />
//                       <input
//                         type="text"
//                         name="address.zipCode"
//                         value={formData.address.zipCode}
//                         onChange={handleChange}
//                         className="w-full px-3 sm:px-4 py-3 sm:py-3.5 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:ring-2 focus:ring-orange-100 outline-none transition-all text-sm sm:text-base"
//                         placeholder="ZIP Code"
//                       />
//                       <input
//                         type="text"
//                         name="address.country"
//                         value={formData.address.country}
//                         onChange={handleChange}
//                         className="w-full px-3 sm:px-4 py-3 sm:py-3.5 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:ring-2 focus:ring-orange-100 outline-none transition-all text-sm sm:text-base"
//                         placeholder="Country"
//                       />
//                     </div>
//                   </div>

//                   {/* Subject Field (hidden but included in form) */}
//                   <input type="hidden" name="subject" value={formData.subject} />

//                   {/* Message Field */}
//                   <div>
//                     <label className="block text-sm font-semibold text-gray-700 mb-2">
//                       Project Details *
//                     </label>
//                     <textarea
//                       name="message"
//                       value={formData.message}
//                       onChange={handleChange}
//                       onFocus={() => setActiveField('message')}
//                       onBlur={() => setActiveField('')}
//                       required
//                       rows="4"
//                       className="w-full px-3 sm:px-4 py-3 sm:py-3.5 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:ring-2 focus:ring-orange-100 outline-none transition-all resize-none text-sm sm:text-base"
//                       placeholder="Tell us about your project vision, timeline, and specific requirements..."
//                       maxLength="500"
//                     />
//                     <p className="text-xs text-gray-500 mt-2">
//                       {formData.message.length}/500 characters
//                     </p>
//                   </div>

//                   {/* Send Copy Checkbox */}
                  

//                   {/* Submit Button */}
//                   <button
//                     type="submit"
//                     disabled={isSubmitting}
//                     className="w-full bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-semibold py-3 sm:py-4 rounded-xl transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl disabled:opacity-70 disabled:cursor-not-allowed disabled:transform-none disabled:shadow-none text-sm sm:text-base"
//                   >
//                     {isSubmitting ? (
//                       <div className="flex items-center justify-center">
//                         <div className="animate-spin rounded-full h-4 w-4 sm:h-5 sm:w-5 border-b-2 border-white mr-2 sm:mr-3"></div>
//                         Sending Inquiry...
//                       </div>
//                     ) : (
//                       <div className="flex items-center justify-center">
//                         <FaPaperPlane className="mr-2 sm:mr-3" />
//                         Send Project Inquiry
//                       </div>
//                     )}
//                   </button>

//                   {/* Debug Info (remove in production) */}
//                   {process.env.NODE_ENV === 'development' && submitError && (
//                     <div className="mt-4 p-3 bg-gray-100 rounded-lg">
//                       <p className="text-xs text-gray-600">Debug: {submitError}</p>
//                     </div>
//                   )}
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default ContactPage;






import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../services/api';
import { 
  FaUser, 
  FaEnvelope, 
  FaPhone, 
  FaMapMarkerAlt, 
  FaHome,
  FaBuilding,
  FaGlobe,
  FaPaperPlane,
  FaCheckCircle,
  FaArrowRight,
  FaStar,
  FaClock,
  FaUsers,
  FaShieldAlt,
  FaPlay,
  FaPause,
  FaCheck,
  FaCalendarAlt,
  FaCalendarDay,
  FaTimesCircle
} from 'react-icons/fa';
import toast from 'react-hot-toast';
import "../../Component/Home/theme.css"; // Import the CSS file
import { MessageSquare } from 'lucide-react';

const ContactPage = () => {
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [activeField, setActiveField] = useState('');
  
  // Add font styles to document head
  useEffect(() => {
    // Add Bell MT and Inter fonts
    const style = document.createElement('style');
    style.textContent = `
      @import url('https://fonts.cdnfonts.com/css/bell-mt');
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
      
      .bell-mt-primary {
        font-family: 'Bell MT', serif !important;
      }
      
      .inter-secondary {
        font-family: 'Inter', sans-serif !important;
      }
      
      body {
        font-family: 'Inter', sans-serif;
      }
      
      h1, h2, h3, h4, h5, h6 {
        font-family: 'Bell MT', serif;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);
  
  // Form data structure
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    preferredDate: '',
    preferredTime: '',
    address: {
      street: '',
      city: '',
      state: '',
      country: 'USA',
      zipCode: ''
    },
    subject: 'Kitchen Cabinet Inquiry',
    message: '',
    sendCopy: true
  });

  // New Jersey Business Hours (Tuesday-Saturday, Closed Sunday & Monday)
  const businessHours = [
    { day: 'Mon', hours: 'Closed', isClosed: true },
    { day: 'Tue', hours: '10:00 AM – 5:00 PM', isClosed: false },
    { day: 'Wed', hours: '10:00 AM – 5:00 PM', isClosed: false },
    { day: 'Thu', hours: '10:00 AM – 5:00 PM', isClosed: false },
    { day: 'Fri', hours: '10:00 AM – 5:00 PM', isClosed: false },
    { day: 'Sat', hours: '10:00 AM – 2:00 PM', isClosed: false },
    { day: 'Sun', hours: 'Closed', isClosed: true }
  ];

  // Time slots available (Tuesday-Friday 10-5, Saturday 10-2)
  const timeSlots = [
    '10:00 AM to 12:00 PM',
    '12:00 PM to 02:00 PM',
    '02:00 PM to 04:00 PM'
  ];

  // Saturday-only time slots
  const saturdayTimeSlots = [
    '10:00 AM to 12:00 PM',
    '12:00 PM to 02:00 PM'
  ];

  // What We Offer features with emoji icons
  const features = [
    { icon: "🗄️", title: 'Cabinets', description: 'Premium quality cabinets custom-built to your specifications' },
    { icon: "🪨", title: 'Countertops', description: 'Durable and beautiful countertop installation' },
    { icon: "🧱", title: 'Backsplash', description: 'Professional backsplash design and installation' },
    { icon: "🎨", title: 'Paint', description: 'Complete painting services for your kitchen' },
    { icon: "🚰", title: 'Sink', description: 'High-quality sink installation with plumbing' },
    { icon: "🔩", title: 'Hardware', description: 'Knobs, pulls, and all finishing hardware' },
    { icon: "⚡", title: 'Electrical', description: 'Any necessary electrical work included' },
    { icon: "👷", title: 'Complete Labor', description: 'Full installation from start to finish' }
  ];

  const toggleVideo = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(e => {
        console.log("Autoplay prevented:", e);
      });
    }
  }, []);

  // Function to get minimum date (tomorrow)
  const getMinDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split('T')[0];
  };

  // Function to get maximum date (60 days from now)
  const getMaxDate = () => {
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 60);
    return maxDate.toISOString().split('T')[0];
  };

  // Function to check if a date is Monday or Sunday
  const isClosedDay = (dateString) => {
    if (!dateString) return false;
    const date = new Date(dateString);
    const day = date.getDay(); // 0 = Sunday, 1 = Monday
    return day === 0 || day === 1; // Closed on Sunday and Monday
  };

  // Function to check if date is Saturday
  const isSaturday = (dateString) => {
    if (!dateString) return false;
    const date = new Date(dateString);
    return date.getDay() === 6; // 6 = Saturday
  };

  // Function to get day name from date
  const getDayName = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[date.getDay()];
  };

  // Get time slots based on selected date
  const getAvailableTimeSlots = () => {
    if (!formData.preferredDate) return timeSlots;
    if (isSaturday(formData.preferredDate)) {
      return saturdayTimeSlots;
    }
    return timeSlots;
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.name.trim()) {
      errors.name = 'Name is required';
    }

    // Email is optional but must be valid if provided
    if (formData.email.trim() && !/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'Email is invalid';
    }

    // Phone validation - flexible for international numbers
    if (!formData.phone.trim()) {
      errors.phone = 'Phone number is required';
    } else if (!/^[\d\s\-\+\(\)]{10,20}$/.test(formData.phone)) {
      errors.phone = 'Enter a valid phone number (10-20 digits, international format accepted)';
    }

    // Check if preferred date is Monday or Sunday
    if (formData.preferredDate && isClosedDay(formData.preferredDate)) {
      const dayName = getDayName(formData.preferredDate);
      errors.preferredDate = `We are closed on ${dayName}s. Please select another date.`;
    }

    // Check if time is selected but no date
    if (formData.preferredTime && !formData.preferredDate) {
      errors.preferredDate = 'Please select a date first';
    }

    if (!formData.message.trim()) {
      errors.message = 'Message is required';
    } else if (formData.message.length < 5) {
      errors.message = 'Message must be at least 5 characters';
    }

    return errors;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (name.includes('.')) {
      const [parent, child] = name.split('.');
      setFormData(prev => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value
        }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));
    }
  };

  const handleDateChange = (e) => {
    const selectedDate = e.target.value;
    
    // Check if selected date is Monday or Sunday
    if (isClosedDay(selectedDate)) {
      const dayName = getDayName(selectedDate);
      toast.error(`We are closed on ${dayName}s. Please select another date.`);
      setFormData(prev => ({
        ...prev,
        preferredDate: '',
        preferredTime: '' // Clear time if closed day is selected
      }));
      return;
    }
    
    setFormData(prev => ({
      ...prev,
      preferredDate: selectedDate,
      preferredTime: '' // Reset time when date changes
    }));
  };

  const handleTimeChange = (e) => {
    const selectedTime = e.target.value;
    setFormData(prev => ({
      ...prev,
      preferredTime: selectedTime
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Clear previous errors
    setSubmitError(null);
    
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      Object.values(errors).forEach(error => {
        if (error) toast.error(error);
      });
      return;
    }

    setIsSubmitting(true);

    // Debug log
    console.log('Submitting form data:', formData);

    // Prepare data for backend - keep phone format as entered
    const submissionData = {
      ...formData,
      phone: formData.phone.trim(), // Keep original formatting
      preferredDate: formData.preferredDate || null,
      preferredTime: formData.preferredTime || '',
      timestamp: new Date().toISOString()
    };

    try {
      console.log('Calling API with:', submissionData);
      
      const response = await apiService.submitContact(submissionData);
      
      console.log('API Response:', response);
      
      if (response.success) {
        toast.success('Message sent successfully! We will contact you within 24 hours.');
        
        // Prepare submission data BEFORE resetting form
        const submissionDataForThankYou = {
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          preferredDate: formData.preferredDate,
          preferredTime: formData.preferredTime,
          subject: formData.subject,
          message: formData.message,
          address: formData.address,
          ...(response.data && { ...response.data }),
          submittedAt: new Date().toLocaleString()
        };
        
        // Reset form
        setFormData({
          name: '',
          email: '',
          phone: '',
          preferredDate: '',
          preferredTime: '',
          address: {
            street: '',
            city: '',
            state: '',
            country: 'USA',
            zipCode: ''
          },
          subject: 'Kitchen Cabinet Inquiry',
          message: '',
          sendCopy: true
        });

        // Navigate to thank you page
        setTimeout(() => {
          navigate('/thank-you', { 
            state: { 
              submissionData: submissionDataForThankYou
            } 
          });
        }, 1500);

      } else {
        const errorMessage = response.message || 'Failed to send message. Please try again.';
        setSubmitError(errorMessage);
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      const errorMessage = error.message || 'Network error. Please check your connection and try again.';
      setSubmitError(errorMessage);
      
      // Provide more specific error messages
      if (error.response) {
        toast.error(`Server error: ${error.response.status}`);
      } else if (error.request) {
        toast.error('No response from server. Please try again later.');
      } else {
        toast.error('Failed to send message. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  // Get current day for highlighting
  const getCurrentDay = () => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[new Date().getDay()];
  };

  // Get available time slots for selected date
  const availableTimeSlots = getAvailableTimeSlots();

  return (
    <div className="min-h-screen inter-secondary">
      {/* Hero Section with Video Background */}
      <section className="relative h-[60vh] sm:h-[70vh] md:h-[75vh] lg:h-[80vh] overflow-hidden">
        <div className="absolute inset-0">
          <video
            ref={videoRef}
            autoPlay
            muted
            loop
            playsInline
            className="absolute inset-0 w-full h-full object-cover"
            poster="/assets/Images/video-poster.jpg"
          >
            <source src="/assets/Images/mobilevideo.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          
          {/* Background Decorative Elements */}
          <div 
            className="absolute top-0 left-0 w-72 h-72 rounded-full -translate-x-1/2 -translate-y-1/2 opacity-20 blur-3xl" 
            aria-hidden="true"
            style={{
              backgroundColor: "var(--color-primary-600)",
            }}
          ></div>
          <div 
            className="absolute bottom-0 right-0 w-96 h-96 rounded-full translate-x-1/3 translate-y-1/3 opacity-20 blur-3xl" 
            aria-hidden="true"
            style={{
              backgroundColor: "var(--color-primary-600)",
            }}
          ></div>
          
          <div className="absolute inset-0" style={{ background: "linear-gradient(to top, var(--overlay-dark) 0%, var(--overlay-semi-dark) 50%, transparent 100%)" }}>
            <div className="container mx-auto h-full px-4 sm:px-6 lg:px-8 flex items-center">
              <div className="max-w-3xl w-full">
                <div 
                  className="inter-secondary inline-flex items-center space-x-2 backdrop-blur-sm px-4 py-2 rounded-full mb-4 sm:mb-6"
                  style={{
                    backgroundColor: "var(--color-primary-500)",
                  }}
                >
                  <FaStar className="text-sm" style={{ color: "var(--color-white)" }} />
                  <span className="text-xs sm:text-sm font-medium" style={{ color: "var(--color-white)" }}>
                    Premium Cabinetry Solutions
                  </span>
                </div>
                
                <h1 className="bell-mt-primary text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-bold mb-3 sm:mb-4 leading-tight" style={{ color: "var(--color-white)" }}>
                  Custom Kitchen Cabinets & Premium Cabinet Solutions by{' '}
                  <span style={{ color: "var(--color-accent-500)" }}>Laminance Cabinetry</span>
                </h1>
                
                <p className="inter-secondary text-base sm:text-lg md:text-xl mb-6 sm:mb-8 max-w-2xl" style={{ color: "rgba(255, 255, 255, 0.9)" }}>
                  Complete kitchen transformations with all-inclusive packages. From concept to completion, we handle everything.
                </p>
                
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                  <button
                    onClick={() => document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' })}
                    className="inter-secondary font-semibold px-6 sm:px-8 py-3 rounded-lg sm:rounded-xl flex items-center justify-center transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg text-sm sm:text-base"
                    style={{
                      background: "var(--color-primary-500)",
                      color: "var(--color-white)",
                    }}
                  >
                    <FaPaperPlane className="mr-2 sm:mr-3" />
                    Get Free Consultation
                  </button>
                  
                  <button
                    onClick={toggleVideo}
                    className="inter-secondary backdrop-blur-sm font-semibold px-4 sm:px-6 py-3 rounded-lg sm:rounded-xl flex items-center justify-center transition-all text-sm sm:text-base"
                    style={{
                      backgroundColor: "var(--bg-white-10)",
                      color: "var(--color-white)",
                      border: "2px solid var(--border-white-10)",
                    }}
                  >
                    {isPlaying ? (
                      <>
                        <FaPause className="mr-2 sm:mr-3" />
                        <span className="hidden sm:inline">Pause Video</span>
                        <span className="sm:hidden">Pause</span>
                      </>
                    ) : (
                      <>
                        <FaPlay className="mr-2 sm:mr-3" />
                        <span className="hidden sm:inline">Play Video</span>
                        <span className="sm:hidden">Play</span>
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What We Offer Section */}
      <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 lg:px-8" style={{ background: "var(--gradient-bg)" }}>
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-8 sm:mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6"
                      style={{
                        background: "var(--bg-primary-10)",
                        border: "1px solid var(--border-primary-20)",
                      }}
                    >
                      <MessageSquare size={14} style={{ color: "var(--color-primary-400)" }} />
                      <span className="text-sm font-medium" style={{ color: "var(--color-primary-400)" }}>
                        Conplete Package Zero Stress.
                      </span>
                    </div>
            
            <h2 className="bell-mt-primary text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4" style={{ color: "var(--color-primary-500)" }}>
              All-Inclusive Kitchen Transformation
            </h2>
            
            <p className="inter-secondary text-base sm:text-lg max-w-3xl mx-auto px-4" style={{ color: "var(--color-gray-600)" }}>
              Everything you need for a complete kitchen renovation, handled by our expert team from start to finish.
            </p>

            {/* Decorative Line */}
            <div className="flex justify-center mt-6" aria-hidden="true">
              <div 
                className="w-24 h-1 rounded-full"
                style={{
                  background: "var(--gradient-primary)",
                }}
              ></div>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-8 sm:mb-12 px-2 sm:px-0">
  {features.map((feature, index) => (
    <div
      key={index}
      className="group bg-white p-4 sm:p-6 rounded-xl sm:rounded-2xl border transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
      style={{
        backgroundColor: "var(--color-white)",
        borderColor: "var(--border-light)",
        boxShadow: "var(--shadow-medium)",
      }}
    >
      {/* Icon and Title - Inline */}
      <div className="flex items-center gap-3 mb-3">
        {/* Icon Container */}
        <div
          className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform"
          style={{
            backgroundColor: "var(--color-primary-500)",
          }}
        >
          <span
            className="text-2xl sm:text-3xl"
            style={{ color: "var(--color-primary-600)" }}
          >
            {feature.icon}
          </span>
        </div>

        {/* Title */}
        <h3
          className="bell-mt-primary text-base sm:text-lg font-semibold"
          style={{ color: "var(--color-primary-500)" }}
        >
          {feature.title}
        </h3>
      </div>

      {/* Description */}
      <p className="inter-secondary text-xs sm:text-sm" style={{ color: "var(--color-gray-600)" }}>
        {feature.description}
      </p>
    </div>
  ))}
</div>

          <div 
            className="rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 text-center relative overflow-hidden"
            style={{
              background: "var(--gradient-primary)",
            }}
          >
            {/* Background Decorative Elements */}
            <div 
              className="absolute top-0 left-0 w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64 rounded-full -translate-x-1/2 -translate-y-1/2 opacity-20 blur-3xl" 
              aria-hidden="true"
              style={{
                backgroundColor: "var(--color-white)",
              }}
            ></div>
            <div 
              className="absolute bottom-0 right-0 w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64 rounded-full translate-x-1/2 translate-y-1/2 opacity-20 blur-3xl" 
              aria-hidden="true"
              style={{
                backgroundColor: "var(--color-white)",
              }}
            ></div>

            <div className="relative z-10 max-w-4xl mx-auto">
              <h3 className="bell-mt-primary text-xl sm:text-2xl md:text-3xl font-bold mb-3 sm:mb-4" style={{ color: "var(--color-white)" }}>
                Complete Package. Zero Stress.
              </h3>
              <p className="inter-secondary text-sm sm:text-base md:text-lg mb-4 sm:mb-6 px-2" style={{ color: "rgba(255, 255, 255, 0.9)" }}>
                Our all-inclusive service includes cabinets, countertops, backsplash, paint, sink, 
                knobs and all materials needed to finish your kitchen. We handle the entire labor 
                to install kitchen, countertops, backsplash, any electric and plumbing work.
              </p>
              <div className="flex flex-wrap justify-center gap-2 sm:gap-3 md:gap-4">
                {["No Hidden Costs", "Single Point of Contact", "Guaranteed Timeline"].map((text, i) => (
                  <div 
                    key={i}
                    className="backdrop-blur-sm px-3 py-1 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm"
                    style={{
                      backgroundColor: "var(--bg-white-10)",
                      border: "1px solid var(--border-white-10)",
                    }}
                  >
                    <span className="font-semibold" style={{ color: "var(--color-white)" }}>{text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section id="contact-form" className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-8 sm:mb-12">
             <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6"
                                  style={{
                                    background: "var(--bg-primary-10)",
                                    border: "1px solid var(--border-primary-20)",
                                  }}
                                >
                                  <MessageSquare size={14} style={{ color: "var(--color-primary-400)" }} />
                                  <span className="text-sm font-medium" style={{ color: "var(--color-primary-400)" }}>
                                    Get Started
                                  </span>
                                </div>
            
            <h2 className="bell-mt-primary text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4" style={{ color: "var(--color-primary-500)" }}>
              Start Your Dream Project
            </h2>
            
            <p className="inter-secondary text-base sm:text-lg max-w-2xl mx-auto px-4" style={{ color: "var(--color-gray-600)" }}>
              Fill out the form below and our team will contact you within 24 hours to discuss your project.
            </p>

            {/* Decorative Line */}
            <div className="flex justify-center mt-6" aria-hidden="true">
              <div 
                className="w-24 h-1 rounded-full"
                style={{
                  background: "var(--gradient-primary)",
                }}
              ></div>
            </div>
            
            {/* Error Display */}
            {submitError && (
              <div className="mt-4 p-4 rounded-xl max-w-md mx-auto" style={{ backgroundColor: "rgba(239, 68, 68, 0.1)", border: "1px solid rgba(239, 68, 68, 0.2)" }}>
                <p className="inter-secondary font-medium" style={{ color: "rgb(239, 68, 68)" }}>Error: {submitError}</p>
                <p className="inter-secondary text-sm mt-1" style={{ color: "rgb(239, 68, 68)" }}>Please try again or call us directly at (862) 450-6069</p>
              </div>
            )}
          </div>

          <div className="grid lg:grid-cols-3 gap-6 sm:gap-8">
            {/* Contact Info Sidebar */}
            <div className="lg:col-span-1">
              <div 
                className="rounded-2xl sm:rounded-3xl p-6 sm:p-8 h-full relative overflow-hidden"
                style={{
                  background: "var(--color-primary-500)",
                }}
              >
                {/* Background Decorative Elements */}
                <div 
                  className="absolute top-0 right-0 w-32 h-32 rounded-full translate-x-1/2 -translate-y-1/2 opacity-20 blur-3xl" 
                  aria-hidden="true"
                  style={{
                    backgroundColor: "var(--color-white)",
                  }}
                ></div>
                <div 
                  className="absolute bottom-0 left-0 w-32 h-32 rounded-full -translate-x-1/2 translate-y-1/2 opacity-20 blur-3xl" 
                  aria-hidden="true"
                  style={{
                    backgroundColor: "var(--color-white)",
                  }}
                ></div>

                <div className="relative z-10">
  <div className="mb-8 sm:mb-10">
    <h3 className="bell-mt-primary text-xl sm:text-2xl font-bold mb-4 sm:mb-6" style={{ color: "var(--color-white)" }}>
      Business Hours
    </h3>
    <div className="space-y-2">
      {businessHours.map((day, index) => {
        const isToday = day.day === getCurrentDay();
        return (
          <div 
            key={index} 
            className="flex items-center justify-between p-3 rounded-lg"
            style={{
              backgroundColor: "var(--color-white)", // White background
            }}
          >
            <div className="flex items-center space-x-3">
  {day.isClosed ? (
    <span className="text-lg sm:text-xl" style={{ color: "var(--color-primary-500)" }}>❌</span>
  ) : (
    <span className="text-lg sm:text-xl" style={{ color: "var(--color-primary-500)" }}>🕒</span>
  )}
  <span className="inter-secondary font-medium" style={{ color: "var(--color-primary-500)" }}>
    {day.day}
  </span>
</div>
            <span className="inter-secondary font-semibold" style={{ color: "var(--color-primary-500)" }}>
              {day.hours}
            </span>
          </div>
        );
      })}
    </div>
  </div>

  <div className="mb-8 sm:mb-10">
    <h3 className="bell-mt-primary text-xl sm:text-2xl font-bold mb-4 sm:mb-6" style={{ color: "var(--color-white)" }}>
      Why Choose Us
    </h3>
    <div className="space-y-4 sm:space-y-6">
      {[
           { icon: "👥", title: 'Expert Team', desc: '15+ years of specialized experience' },                    
    { icon: "🛡️", title: 'Warranty', desc: '5-year limited warranty' }

      ].map((item, index) => (
        <div key={index} className="flex items-start space-x-3 sm:space-x-4">
          <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: "var(--color-white)" }}>
            {/* Icons with primary color */}
            <span style={{ color: "var(--color-primary-500)", fontSize: "1.5rem" }}>{item.icon}</span>
          </div>
          <div>
            <h4 className="bell-mt-primary font-semibold text-sm sm:text-base" style={{ color: "var(--color-white)" }}>{item.title}</h4>
            <p className="inter-secondary text-xs sm:text-sm mt-1" style={{ color: "var(--color-white)" }}>{item.desc}</p>
          </div>
        </div>
      ))}
    </div>
  </div>

  <div className="" style={{ borderColor: "" }}>
    <h3 className="bell-mt-primary text-xl sm:text-2xl font-bold mb-4 sm:mb-6" style={{ color: "var(--color-white)" }}>
      Contact Directly
    </h3>
    <div className="space-y-3 sm:space-y-4">
      <a 
        href="tel:8624506069"
        className="inter-secondary flex items-center justify-between p-3 rounded-xl transition-all text-sm sm:text-base"
        style={{
          backgroundColor: "var(--color-white)", // White background
          color: "var(--color-primary-500)", // Primary color text
          border: "1px solid var(--border-white-10)",
        }}
      >
        <span className="font-medium">Call Now</span>
        <span className="font-bold text-sm">(862) 450-6069</span> {/* Added phone number */}
      </a>
      <a 
                       href="mailto:Contactus@laminance.com"
                       className="flex items-center justify-between p-3 bg-white/10 rounded-xl hover:bg-white/20 transition-all text-sm sm:text-base"
                       style={{
          backgroundColor: "var(--color-white)", // White background
          color: "var(--color-primary-500)", // Primary color text
          border: "1px solid var(--border-white-10)",
        }}
                     >
                       <span className="font-medium ">Email Us</span>
                       <span className="font-bold text-sm">Contactus@laminance.com</span>                     </a>
    </div>
  </div>
</div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-2">
              <div 
                className="rounded-2xl sm:rounded-3xl border p-4 sm:p-6 md:p-8 shadow-lg"
                style={{
                  backgroundColor: "var(--color-white)",
                  borderColor: "var(--border-light)",
                  boxShadow: "var(--shadow-medium)",
                }}
              >
                <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                    {/* Name Field */}
                    <div>
                      <label className="block text-sm font-semibold mb-2 inter-secondary" style={{ color: "var(--color-primary-500)" }}>
                        Full Name *
                      </label>
                      <div className="relative">
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          onFocus={() => setActiveField('name')}
                          onBlur={() => setActiveField('')}
                          required
                          className="w-full pl-3 sm:pl-4 pr-3 sm:pr-4 py-3 sm:py-3.5 border-2 rounded-xl outline-none transition-all text-sm sm:text-base inter-secondary"
                          style={{
                            borderColor: activeField === 'name' ? "var(--color-primary-500)" : "var(--border-medium)",
                            color: "var(--color-black)",
                          }}
                          placeholder="John Smith"
                        />
                      </div>
                    </div>

                    {/* Email Field - Optional */}
                    <div>
                      <label className="block text-sm font-semibold mb-2 inter-secondary" style={{ color: "var(--color-primary-500)" }}>
                        Email Address (Optional)
                      </label>
                      <div className="relative">
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          onFocus={() => setActiveField('email')}
                          onBlur={() => setActiveField('')}
                          className="w-full pl-3 sm:pl-4 pr-3 sm:pr-4 py-3 sm:py-3.5 border-2 rounded-xl outline-none transition-all text-sm sm:text-base inter-secondary"
                          style={{
                            borderColor: activeField === 'email' ? "var(--color-primary-500)" : "var(--border-medium)",
                            color: "var(--color-black)",
                          }}
                          placeholder="john@example.com"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Phone Field */}
                  <div>
                    <label className="block text-sm font-semibold mb-2 inter-secondary" style={{ color: "var(--color-primary-500)" }}>
                      Phone Number *
                    </label>
                    <div className="relative">
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        onFocus={() => setActiveField('phone')}
                        onBlur={() => setActiveField('')}
                        required
                        className="w-full pl-3 sm:pl-4 pr-3 sm:pr-4 py-3 sm:py-3.5 border-2 rounded-xl outline-none transition-all text-sm sm:text-base inter-secondary"
                        style={{
                          borderColor: activeField === 'phone' ? "var(--color-primary-500)" : "var(--border-medium)",
                          color: "var(--color-black)",
                        }}
                        placeholder="+1 (862) 450-6069 or 8624506069"
                      />
                      <p className="inter-secondary text-xs mt-2" style={{ color: "var(--color-primary-500)" }}>
                        Enter phone number in any format (10-20 digits). International numbers accepted.
                      </p>
                    </div>
                  </div>

                  {/* Preferred Date and Time Section */}
                  <div className="space-y-3 sm:space-y-4">
                    <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: "var(--color-primary-100)" }}>
  <span className="text-lg sm:text-xl" style={{ color: "var(--color-primary-500)" }}>📅</span>
</div>
                      <h3 className="bell-mt-primary text-base sm:text-lg font-semibold" style={{ color: "var(--color-primary-500)" }}>
                        Preferred Consultation (Optional)
                      </h3>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                      <div>
                        <input
                          type="date"
                          name="preferredDate"
                          value={formData.preferredDate}
                          onChange={handleDateChange}
                          min={getMinDate()}
                          max={getMaxDate()}
                          className="w-full px-3 sm:px-4 py-3 sm:py-3.5 border-2 rounded-xl outline-none transition-all text-sm sm:text-base inter-secondary"
                          style={{
                            borderColor: "var(--border-medium)",
                            color: "var(--color-black)",
                          }}
                        />
                        <p className="inter-secondary text-xs mt-1" style={{ color: "var(--color-primary-500)" }}>
                          Tuesday-Saturday (Closed Sun/Mon)
                        </p>
                      </div>

                      <div>
                        <select
                          name="preferredTime"
                          value={formData.preferredTime}
                          onChange={handleTimeChange}
                          className="w-full px-3 sm:px-4 py-3 sm:py-3.5 border-2 rounded-xl outline-none transition-all text-sm sm:text-base inter-secondary"
                          style={{
                            borderColor: "var(--border-medium)",
                            color: "var(--color-black)",
                          }}
                        >
                          <option value="">Select time</option>
                          {availableTimeSlots.map((slot, index) => (
                            <option key={index} value={slot}>
                              {slot}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* Address Section */}
                  <div className="space-y-3 sm:space-y-4">
                    <div className="flex items-center space-x-3">
                      <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: "var(--color-primary-100)" }}>
  <span className="text-lg sm:text-xl" style={{ color: "var(--color-primary-500)" }}>🏠</span>
</div>
                      <h3 className="bell-mt-primary text-base sm:text-lg font-semibold" style={{ color: "var(--color-primary-500)" }}>
                        Project Address (Optional)
                      </h3>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                      <input
                        type="text"
                        name="address.street"
                        value={formData.address.street}
                        onChange={handleChange}
                        className="w-full px-3 sm:px-4 py-3 sm:py-3.5 border-2 rounded-xl outline-none transition-all text-sm sm:text-base inter-secondary"
                        style={{
                          borderColor: "var(--border-medium)",
                          color: "var(--color-black)",
                        }}
                        placeholder="Street address"
                      />
                      <input
                        type="text"
                        name="address.city"
                        value={formData.address.city}
                        onChange={handleChange}
                        className="w-full px-3 sm:px-4 py-3 sm:py-3.5 border-2 rounded-xl outline-none transition-all text-sm sm:text-base inter-secondary"
                        style={{
                          borderColor: "var(--border-medium)",
                          color: "var(--color-black)",
                        }}
                        placeholder="City"
                      />
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
                      <input
                        type="text"
                        name="address.state"
                        value={formData.address.state}
                        onChange={handleChange}
                        className="w-full px-3 sm:px-4 py-3 sm:py-3.5 border-2 rounded-xl outline-none transition-all text-sm sm:text-base inter-secondary"
                        style={{
                          borderColor: "var(--border-medium)",
                          color: "var(--color-black)",
                        }}
                        placeholder="State (e.g., NJ)"
                      />
                      <input
                        type="text"
                        name="address.zipCode"
                        value={formData.address.zipCode}
                        onChange={handleChange}
                        className="w-full px-3 sm:px-4 py-3 sm:py-3.5 border-2 rounded-xl outline-none transition-all text-sm sm:text-base inter-secondary"
                        style={{
                          borderColor: "var(--border-medium)",
                          color: "var(--color-black)",
                        }}
                        placeholder="ZIP Code"
                      />
                      <input
                        type="text"
                        name="address.country"
                        value={formData.address.country}
                        onChange={handleChange}
                        className="w-full px-3 sm:px-4 py-3 sm:py-3.5 border-2 rounded-xl outline-none transition-all text-sm sm:text-base inter-secondary"
                        style={{
                          borderColor: "var(--border-medium)",
                          color: "var(--color-black)",
                        }}
                        placeholder="Country"
                      />
                    </div>
                  </div>

                  {/* Subject Field (hidden but included in form) */}
                  <input type="hidden" name="subject" value={formData.subject} />

                  {/* Message Field */}
                  <div>
                    <label className="block text-sm font-semibold mb-2 inter-secondary" style={{ color: "var(--color-primary-500)" }}>
                      Project Details *
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      onFocus={() => setActiveField('message')}
                      onBlur={() => setActiveField('')}
                      required
                      rows="4"
                      className="w-full px-3 sm:px-4 py-3 sm:py-3.5 border-2 rounded-xl outline-none transition-all resize-none text-sm sm:text-base inter-secondary"
                      style={{
                        borderColor: activeField === 'message' ? "var(--color-primary-500)" : "var(--border-medium)",
                        color: "var(--color-black)",
                      }}
                      placeholder="Tell us about your project vision, timeline, and specific requirements..."
                      maxLength="500"
                    />
                    <p className="inter-secondary text-xs mt-2" style={{ color: "var(--color-primary-500)" }}>
                      {formData.message.length}/500 characters
                    </p>
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="inter-secondary w-full font-semibold py-3 sm:py-4 rounded-xl transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl disabled:opacity-70 disabled:cursor-not-allowed disabled:transform-none disabled:shadow-none text-sm sm:text-base"
                    style={{
                      background: "var(--gradient-primary)",
                      color: "var(--color-white)",
                    }}
                  >
                    {isSubmitting ? (
                      <div className="flex items-center justify-center">
                        <div className="animate-spin rounded-full h-4 w-4 sm:h-5 sm:w-5 border-b-2 border-white mr-2 sm:mr-3"></div>
                        Sending Inquiry...
                      </div>
                    ) : (
                      <div className="flex items-center justify-center">
                        <FaPaperPlane className="mr-2 sm:mr-3" />
                        Send Project Inquiry
                      </div>
                    )}
                  </button>

                  {/* Debug Info (remove in production) */}
                  {process.env.NODE_ENV === 'development' && submitError && (
                    <div className="mt-4 p-3 rounded-lg" style={{ backgroundColor: "var(--color-gray-100)" }}>
                      <p className="inter-secondary text-xs" style={{ color: "var(--color-gray-600)" }}>Debug: {submitError}</p>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;



